module.exports = __webpack_public_path__ + "static/media/dark-theme-running.319ab76a.svg";